export const validateForm = (formData) => {
  let errors = {};
  if (!formData.restaurantId)
    errors.restaurantId = "Swiggy Restaurant ID is required";
  if (!formData.cityName) errors.cityName = "City Name is required";
  if (!formData.restaurantName)
    errors.restaurantName = "Restaurant Name is required";
  if (!formData.emailAddress) {
    errors.emailAddress = "Email address is required";
  } else if (
    !/^[^\s@]+@[^\s@]+\.[^\s@.]+$/.test(formData.emailAddress) ||
    formData.emailAddress.includes("..")
  ) {
    // !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(formData.emailAddress)
    errors.emailAddress = "Invalid email format";
  }
  if (!formData.contactNo) {
    errors.contactNo = "Phone number is required";
  } else if (!/^[0-9]{10}$/.test(formData.contactNo)) {
    errors.contactNo = "Phone number must be exactly 10 digits";
  }

  if (!formData.vendors || formData.vendors.length === 0) {
    errors.vendors = "Please select at least one vendor";
  }
  if (!formData.dishes || formData.dishes.length === 0) {
    errors.dishes = "Please select at least one dishes";
  }
  if (!formData.cuisines || formData.cuisines.length === 0) {
    errors.cuisines = "Please select at least one cuisines";
  }
  return errors;
};
